import React from 'react'
import { MDBContainer, MDBRow, MDBCol ,MDBView,MDBCardTitle,MDBCardBody,MDBCard,MDBCardText} from 'mdbreact'

export default function boardMembers() {
    return (
        <div>
            <section className="text-center p-5 black">
                <br  />
            </section>
            <section className="text-center">
                <MDBContainer>
                    <MDBCard className="p-3 my-3 z-depth-2 text-center">
                             <h1>Board Members</h1>
                    </MDBCard>
                </MDBContainer>
                <MDBContainer>
                    <MDBRow>
                        <MDBCol md="4">
                        <div className="testmonial ">
                            <MDBCardBody>
                            <div class="avatar mx-auto" >
                            <center>
                            <MDBView hover zoom>
                            <img 
                            src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
                            className="rounded-circle z-depth-1 img-fluid m-3" 
                            
                            />
                            </MDBView>
                            </center>
                        
                        </div>

                            <MDBCardTitle className="mt-4">
                            Anna Deynah
                            </MDBCardTitle>
                            <h6 class="font-weight-bold blue-text my-3">Web Designer</h6>
                        
                            </MDBCardBody>
                         </div>
                        </MDBCol>
                        <MDBCol md="4">
                        <div className="testmonial ">
                            <MDBCardBody>
                            <div class="avatar mx-auto" >
                            <center>
                            <MDBView hover zoom>
                            <img 
                            src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
                            className="rounded-circle z-depth-1 img-fluid m-3" 
                            
                            />
                            </MDBView>
                            </center>
                        
                        </div>

                            <MDBCardTitle className="mt-4">
                            Anna Deynah
                            </MDBCardTitle>
                            <h6 class="font-weight-bold blue-text my-3">Web Designer</h6>
                        
                            </MDBCardBody>
                         </div>
                        </MDBCol>      <MDBCol md="4">
                        <div className="testmonial ">
                            <MDBCardBody>
                            <div class="avatar mx-auto" >
                            <center>
                            <MDBView hover zoom>
                            <img 
                            src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg"
                            className="rounded-circle z-depth-1 img-fluid m-3" 
                            
                            />
                            </MDBView>
                            </center>
                        
                        </div>

                            <MDBCardTitle className="mt-4">
                            Anna Deynah
                            </MDBCardTitle>
                            <h6 class="font-weight-bold blue-text my-3">Web Designer</h6>
                        
                            </MDBCardBody>
                         </div>
                        </MDBCol>
                    </MDBRow>
                </MDBContainer>
            </section>
        </div>
    )
}
